import _extends from "@babel/runtime/helpers/extends";
import "core-js/modules/es6.function.name.js";
import * as React from 'react';
import defaultRenderEmpty from './renderEmpty';
import { Locale } from '../../wui-locale/src/locale-provider';
import { SizeType } from './SizeContext'; // import { RequiredMark } from '../form/Form';
// export interface ConfigConsumerProps {
//   getTargetContainer?: () => HTMLElement;
//   getPopupContainer?: (triggerNode: HTMLElement) => HTMLElement;
//   rootPrefixCls?: string;
//   iconPrefixCls?: string;
//   getPrefixCls: (suffixCls?: string, customizePrefixCls?: string) => string;
//   renderEmpty: RenderEmptyHandler;
//   csp?: CSPConfig;
//   autoInsertSpaceInButton?: boolean;
//   input?: {
//     autoComplete?: string;
//   };
//   locale?: Locale;
//   pageHeader?: {
//     ghost: boolean;
//   };
//   direction?: DirectionType;
//   space?: {
//     size?: SizeType | number;
//   };
//   virtual?: boolean;
//   dropdownMatchSelectWidth?: boolean;
//   form?: {
//     requiredMark?: RequiredMark;
//   };
// }

var defaultGetPrefixCls = function defaultGetPrefixCls(suffixCls, customizePrefixCls) {
  if (customizePrefixCls) return customizePrefixCls;
  return suffixCls ? "u-".concat(suffixCls) : 'u';
};

export var ConfigContext = /*#__PURE__*/React.createContext({
  // We provide a default function for Context without provider
  getPrefixCls: defaultGetPrefixCls,
  renderEmpty: defaultRenderEmpty,
  locale: Locale,
  size: "md",
  antd: false
});
export var ConfigConsumer = ConfigContext.Consumer;
export function withConfigConsumer(config) {
  return function withConfigConsumerFunc(Component) {
    // Wrap with ConfigConsumer. Since we need compatible with react 15, be care when using ref methods
    var SFC = function SFC(props) {
      return /*#__PURE__*/React.createElement(ConfigConsumer, null, function (configProps) {
        var basicPrefixCls = config.prefixCls;
        var getPrefixCls = configProps.getPrefixCls;
        var customizePrefixCls = props.prefixCls;
        var prefixCls = getPrefixCls(basicPrefixCls, customizePrefixCls);
        return /*#__PURE__*/React.createElement(Component, _extends({}, configProps, props, {
          prefixCls: prefixCls
        }));
      });
    };

    var cons = Component.constructor;
    var name = cons && cons.displayName || Component.name || 'Component';
    SFC.displayName = "withConfigConsumer(".concat(name, ")");
    return SFC;
  };
}


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-provider/src/context.js